import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useSearch = (): IGlobalStore['globalSearch'] => {
  return useSelector((store: IReducerStore) => store.global.globalSearch);
};
